import { useNavigate } from "react-router-dom";
import { ScanLine, ListChecks, Scale, FileCheck2, Lock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import SiteLayout from "@/components/SiteLayout";

const steps = [
  { icon: ScanLine, t: "1. Carichi il preventivo", d: "Carica il documento in PDF, oppure una foto o scansione. Accettiamo anche preventivi fotografati con il telefono. Il file viene trasformato in dati strutturati: singole voci, quantità, unità di misura e prezzi." },
  { icon: ListChecks, t: "2. Completi i dati mancanti", d: "Ti chiediamo solo ciò che serve e non è già nel documento: il Comune o CAP del lavoro, la tipologia di intervento e, se utile, la superficie indicativa. Nulla di più." },
  { icon: Scale, t: "3. Analizziamo voce per voce", d: "Confrontiamo ogni lavorazione con i riferimenti di mercato disponibili per l’area, verifichiamo la completezza, individuiamo possibili extracosti e segnaliamo le ambiguità. Distinguiamo sempre fatti, inferenze e benchmark." },
  { icon: FileCheck2, t: "4. Ricevi il report", d: "Ottieni una valutazione generale con punteggio e livello di rischio, l’analisi dettagliata, le domande concrete da fare all’impresa e un messaggio pronto da inviare. Un anteprima è gratuita; il report completo costa €9,99." },
];

export default function ComeFunziona() {
  const navigate = useNavigate();
  return (
    <SiteLayout
      seo={{ title: "Come funziona", description: "Come funziona OKKIO: carichi il preventivo, completi i dati mancanti, analizziamo ogni voce e ricevi un report indipendente con domande pronte per l’impresa.", path: "/come-funziona" }}
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Come funziona", to: "/come-funziona" }]}
      narrow>
      <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">Come funziona OKKIO</h1>
      <p className="mt-5 text-lg text-slate-600 leading-relaxed">
        Una seconda opinione indipendente sul preventivo della tua ristrutturazione, in pochi minuti.
        Ecco cosa succede dal caricamento al report.
      </p>

      <div className="mt-10 space-y-4">
        {steps.map((s) => (
          <div key={s.t} className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-7">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center"><s.icon className="w-5 h-5 text-slate-700" strokeWidth={1.75} /></span>
              <h2 className="font-heading text-xl font-semibold text-slate-900">{s.t}</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-2xl bg-slate-900 text-white p-6 flex items-start gap-3">
        <Lock className="w-5 h-5 text-slate-300 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
        <p className="text-sm leading-relaxed text-slate-200">
          OKKIO fornisce una valutazione indipendente a scopo informativo per aiutarti a fare le domande giuste.
          Non sostituisce il sopralluogo o la consulenza di un professionista abilitato.
        </p>
      </div>

      <Button data-testid="cf-cta" onClick={() => navigate("/controlla-preventivo")}
        className="mt-8 rounded-full h-14 px-8 text-base font-semibold bg-[#3157F6] hover:bg-[#2444D8] active:scale-95 transition-transform">
        Controlla il tuo preventivo <ArrowRight className="w-5 h-5 ml-1" />
      </Button>
    </SiteLayout>
  );
}
